import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=f3e1e328&scoped=true"
import script from "./Bundles.vue?vue&type=script&lang=js"
export * from "./Bundles.vue?vue&type=script&lang=js"
import style0 from "./Bundles.vue?vue&type=style&index=0&id=f3e1e328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e1e328",
  null
  
)

export default component.exports